<template>
    <div class="admin-buttons mt-10">
        <div
            v-if="errorMessage"
            class="mb-4 text-red"
        >
            {{ errorMessage }}
        </div>
        <div class="flex">
            <div
                class="admin-buttons_button m-max"
                v-if="showSave"
            >
                <FormBtn
                    @click="saveCloseClicked"
                    variant="cms"
                    :disabled="saveAndCloseDisabled"
                    :working="saveAndCloseWorking"
                >
                    Save & Close
                </FormBtn>
            </div>

            <div
                class="admin-buttons_button m-max ml-4"
                v-if="showSave"
            >
                <FormBtn
                    @click="saveClicked"
                    variant="cms"
                    :disabled="saveDisabled"
                    :working="saveWorking"
                >
                    Save
                </FormBtn>
            </div>

            <div
                class="admin-buttons_button m-max ml-4"
                v-if="showPublish"
            >
                <FormBtn
                    @click="publishClicked"
                    variant="cms-outline"
                    :disabled="publishDisabled"
                    :working="publishWorking"
                >
                    Publish
                </FormBtn>
            </div>

            <div
                class="admin-buttons_button m-max ml-4"
                v-if="showUnpublish"
            >
                <FormBtn
                    @click="unpublishClicked"
                    variant="cms-outline"
                    :disabled="unpublishDisabled"
                    :working="unpublishWorking"
                >
                    Unpublish
                </FormBtn>
            </div>

            <div
                class="admin-buttons_button m-max ml-4"
                v-if="showCancel"
            >
                <FormBtn
                    variant="cms-outline"
                    @click="cancelClicked"
                    :disabled="cancelDisabled"
                    :working="cancelWorking"
                >
                    Close
                </FormBtn>
            </div>

            <div
                class="admin-buttons_button m-max ml-4"
                v-if="showDelete"
            >
                <FormBtn
                    variant="cms-outline-full"
                    @click="deleteClicked"
                    :disabled="deleteDisabled"
                    :working="deleteWorking"
                    title="Delete"
                >
                    <IconRenderer name="Cross" />
                </FormBtn>
            </div>
        </div>
    </div>
</template>

<script>

import {hasEvents, accessesData} from "@/services/data-layer/composers";
import {inject} from "vue";

export default {
    setup() {
        const {listen} = hasEvents();
        const {id, isPublished} = accessesData();
        const errors = inject('errors');

        return {
            listen,
            id,
            isPublished,
            errors,
        }
    },

    data() {
        return {
            working: null,
        }
    },

    computed: {
        showSave() {
            return true;
        },

        showCancel() {
            return true;
        },

        showDelete() {
            return true;
        },

        showPublish() {
            return this.id && !this.isPublished;
        },

        showUnpublish() {
            return this.isPublished;
        },

        saveDisabled() {
            return this.working && this.working !== 'save';
        },

        saveWorking() {
            return this.working && this.working === 'save';
        },

        saveAndCloseDisabled() {
            return this.working && this.working !== 'saveClose';
        },

        saveAndCloseWorking() {
            return this.working && this.working === 'saveClose';
        },

        publishDisabled() {
            return this.working && this.working !== 'publish';
        },

        publishWorking() {
            return this.working && this.working === 'publish';
        },

        unpublishDisabled() {
            return this.working && this.working !== 'unpublish';
        },

        unpublishWorking() {
            return this.working && this.working === 'unpublish';
        },

        cancelDisabled() {
            return this.working && this.working !== 'cancel';
        },

        cancelWorking() {
            return this.working && this.working === 'cancel';
        },

        deleteDisabled() {
            return this.working && this.working !== 'delete';
        },

        deleteWorking() {
            return this.working && this.working === 'delete';
        },

        errorMessage() {
            return this.errors.any() ? 'Please check errors above' : '';
        }
    },

    emits: ['saveClose', 'save', 'publish', 'unpublish', 'cancel', 'delete'],

    methods: {
        saveCloseClicked() {
            this.$emit('saveClose');
        },

        saveClicked() {
            this.$emit('save');
        },

        publishClicked() {
            this.$emit('publish');
        },

        unpublishClicked() {
            this.$emit('unpublish');
        },

        cancelClicked() {
            this.$emit('cancel');
        },

        deleteClicked() {
            if (confirm('Are you sure you would like to delete this record?')) {
                this.$emit('delete');
            }
        },
    },

    mounted() {
        this.listen({
            saving: () => {
                this.working = 'save';
            },

            saved: () => {
                this.working = null;
            },

            savedAndClosing: () => {
                this.working = 'saveClose';
            },

            savedAndClosed: () => {
                this.working = null;
            },

            publishing: () => {
                this.working = 'publish';
            },

            published: () => {
                this.working = null;
            },

            unpublishing: () => {
                this.working = 'unpublish';
            },

            unpublished: () => {
                this.working = null;
            },

            destroying: () => {
                this.working = 'delete';
            },

            destroyed: () => {
                this.working = null;
            },

            invalidResource: () => {
                this.working = null;
            },
        });
    }
}
</script>


